import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class MarketingApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/marketing' + path, queryMap);
  }

  findHomeCarousels() {
    const url = this.buildurl('/home/carousels');
    return this.http.fget(url);
  }

  getMarketingArticle(id: number) {
    const url = this.buildurl(`/article/${id}`);
    return this.http.fget(url);
  }

  findMarketingArticles(query: string, page: number, pageSize: number) {
    const url = this.buildurl('/articles', {
      query,
      page,
      page_size: pageSize,
    });
    return this.http.fget(url);
  }

  findHotarticles() {
    const url = this.buildurl('/help/hotarticles');
    return this.http.fget(url);
  }

  findArticles(query: string, id: number, page: number, page_size: number) {
    const q = { query, id, page, page_size };
    const url = this.buildurl('/help/articles', q);
    return this.http.fget(url);
  }

  findArticlesTag(id: number, page: number, page_size: number) {
    const q = { id, page, page_size };
    const url = this.buildurl(`/help/articles/${id}`, q);
    return this.http.fget(url);
  }

  findArticleTags() {
    const url = this.buildurl('/help/articles/tags');
    return this.http.fget(url);
  }

  findArticleCategories() {
    const url = this.buildurl('/help/articles/categories');
    return this.http.fget(url);
  }

  findArticlePlatform(
    platform_id: number,
    phase: string,
    page: number,
    page_size: number
  ) {
    const q = { platform_id, phase, page, page_size };
    const url = this.buildurl('/help/articles/platform', q);
    return this.http.fget(url);
  }
}
